import * as yup from "yup";

export const VerifyBankDialogueValidationSchema = yup.object().shape({
  verifyBranchTransitNo: yup
    .string()
    .required("Branch/Transit No. is required")
    .max(5, "Maximum length 5 characters"),
  verifyBankNo: yup.string().required("bank No. is required"),
});
